import {
  homeActionTypes,
  HomeAction,
  HomeState
} from '../../types/home'

const initialState = {
  leftMenuStatus: window.innerWidth <= 992 ? true : false,
  rightMenuStatus:   window.innerWidth <= 992 ? false : true ,
  settingMenuStatus: false,
  statusTemplate: false,
  messageList: []
}

const homeReducer = (state = initialState, action: HomeAction): HomeState => {
  switch (action.type) {
    case homeActionTypes.LEFTMENUTOGGLE:
      return {
        ...state,
        leftMenuStatus: action.payload ?? !state.leftMenuStatus,
      };
    case homeActionTypes.RIGHTMENUTOGGLE:
      return {
        ...state,
        rightMenuStatus: action.payload ?? !state.rightMenuStatus,
      };
    case homeActionTypes.SETTINGMENUTOGGLE:
      return {
        ...state,
        settingMenuStatus: action.payload ?? !state.settingMenuStatus,
      };
    case homeActionTypes.REQUESTSAVEDOCUMENT:
      return {
        ...state,
        statusTemplate: true,
      };
    case homeActionTypes.SUCCESSSAVEDOCUMENT:
      return {
        ...state,
        statusTemplate: false,
      };
    case homeActionTypes.REQUESTGETMESSAGELIST:
      return {
        ...state,
        messageList: [],
      };
    case homeActionTypes.SUCCESSGETMESSAGELIST:
      return {
        ...state,
        messageList: action.payload,
      };
    case homeActionTypes.ERRORGETMESSAGELIST:
      return {
          ...state,
          messageList: [],
      };

    default:
      return state;
  }
};

export default homeReducer
